function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 55,
  cy: 55,
  r: 55,
  fill: "#0084ff",
  opacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  "data-name": "Oval",
  cx: 45,
  cy: 45,
  r: 45,
  transform: "translate(10 10)",
  fill: "#0084ff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "play",
  transform: "translate(47 44)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M15.71,9.194,3.166.607A3.062,3.062,0,0,0,1.518,0C.58,0,0,.753,0,2.013V20.572c0,1.259.579,2.01,1.515,2.01a3.037,3.037,0,0,0,1.641-.608l12.549-8.587a2.575,2.575,0,0,0,1.254-2.1A2.566,2.566,0,0,0,15.71,9.194Z",
  transform: "translate(0.024)",
  fill: "#fff"
}));

function SvgSliderPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_13_1",
    "data-name": "Component 13 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderPlay);
export default __webpack_public_path__ + "static/media/sliderPlay.ecf12518.svg";
export { ForwardRef as ReactComponent };